import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

const NotificationsPage = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchNotifications();
    }
  }, [token]);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/notifications`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(response.data);
    } catch (error) {
      toast.error('Gagal memuat notifikasi');
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (notifId) => {
    try {
      await axios.patch(`${API}/notifications/${notifId}/read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchNotifications();
    } catch (error) {
      console.error('Error marking as read:', error);
    }
  };

  const handleNotificationClick = (notif) => {
    markAsRead(notif.id);
    
    // Navigate based on notification type
    if (notif.tipe === 'validasi_approved' && notif.t_registrasi_id) {
      navigate(`/berkas/${notif.t_registrasi_id}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-gradient-ltb-r text-white py-6 px-6 shadow-lg">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold">Notifikasi & To-Do</h1>
            <p className="text-white/80 mt-1">Lihat semua notifikasi dan tindakan yang perlu dilakukan</p>
          </div>
          <button
            onClick={() => navigate('/home')}
            className="bg-white/20 hover:bg-white/30 px-6 py-2 rounded-lg font-semibold transition-all"
          >
            ← Kembali
          </button>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        {loading ? (
          <div className="text-center py-12">Loading...</div>
        ) : notifications.length === 0 ? (
          <div className="bg-white rounded-lg shadow-md p-12 text-center">
            <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
            <p className="text-gray-600 text-lg">Tidak ada notifikasi</p>
          </div>
        ) : (
          <div className="space-y-4">
            {notifications.map((notif) => (
              <div
                key={notif.id}
                onClick={() => handleNotificationClick(notif)}
                className={`bg-white rounded-lg shadow-md p-6 transition-all cursor-pointer hover:shadow-lg ${
                  !notif.dibaca ? 'border-l-4 border-ltb-bright' : ''
                }`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="text-lg font-bold text-gray-800">{notif.judul}</h3>
                      {!notif.dibaca && (
                        <span className="bg-ltb-bright text-white text-xs px-2 py-1 rounded-full">
                          Baru
                        </span>
                      )}
                    </div>
                    <p className="text-gray-700 mb-2">{notif.pesan}</p>
                    <p className="text-sm text-gray-500">
                      {new Date(notif.created_at).toLocaleString('id-ID')}
                    </p>
                    
                    {notif.tipe === 'validasi_approved' && (
                      <div className="mt-4">
                        <button
                          className="bg-gradient-ltb-r text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/berkas/${notif.t_registrasi_id}`);
                          }}
                        >
                          Lengkapi Berkas Tambahan →
                        </button>
                      </div>
                    )}
                  </div>
                  
                  {notif.tipe === 'validasi_approved' && (
                    <div className="ml-4">
                      <span className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-semibold">
                        ✓ Diterima
                      </span>
                    </div>
                  )}
                  {notif.tipe === 'validasi_rejected' && (
                    <div className="ml-4">
                      <span className="inline-block bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-semibold">
                        ✗ Ditolak
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;
